@import '~style-sheet-helpers/core.less';

.content-width {
  display: inline-block;
}

.dropdown-list {
  > *:not(:last-child) {
    margin-bottom: 10px;
  }
}

.preset-native-dropdown {
  width: 250px;
  margin-left: 10px;

  && button {
    border-radius: 4px;
    font-size: 16px;
    padding: 4px 5px 5px;
  }
}

.dropdown-with-label {
  display: flex;
  font-size: 14px;
}

.label {
  white-space: nowrap;
  line-height: 30px;
  padding-right: 10px;
}
